import React, { useEffect, useState } from 'react';
import SchemeDrawer from '../Billing/SchemeDrawer';
import { ActionMode } from '../../../../common/enums/common.enum';
import { BillingSchemeDto } from '../../../../common/interfaces/invoicing.interface';
import { getBillingSchemes, getBillingSettings } from '../../../../api/invoicing.api';

/**
 * A group's price list opened from its page: the one it is on, or a new one with the group
 * already ticked. Opens once what the drawer needs - the scheme, and whether VAT applies -
 * is in.
 */
const GroupSchemeDrawer: React.FC<{
  kindergartenId: string;
  groupId: string;
  schemeId: string | null;
  onClose: () => void;
  onSaved: () => void;
}> = ({ kindergartenId, groupId, schemeId, onClose, onSaved }) => {
  const [ready, setReady] = useState<{ scheme: BillingSchemeDto | null; vat: boolean } | null>(null);

  useEffect(() => {
    let cancelled = false;
    Promise.all([getBillingSettings(kindergartenId), schemeId ? getBillingSchemes(kindergartenId) : Promise.resolve(null)])
      .then(([settings, schemes]) => {
        if (cancelled) return;
        const scheme = schemes?.results?.find(entry => entry.id === schemeId) ?? null;
        setReady({ scheme, vat: !!settings.results?.isInVatSystem });
      })
      .catch(() => !cancelled && onClose());
    return () => {
      cancelled = true;
    };
  }, [kindergartenId, schemeId, onClose]);

  if (!ready) return null;
  return (
    <SchemeDrawer
      mode={ready.scheme ? ActionMode.EDIT : ActionMode.CREATE}
      kindergartenId={kindergartenId}
      vatApplicable={ready.vat}
      scheme={ready.scheme}
      presetGroupIds={[groupId]}
      onClose={onClose}
      onSaved={onSaved}
    />
  );
};

export default GroupSchemeDrawer;
